import {SxType} from '@baseTypes/sx/sxTypes'

export default {
	header: {
		display: 'grid',
		gridTemplateColumns: {
			xs: '1fr',
			md: '1fr auto 1fr',
		},
		alignItems: 'center',
		gap: 1,
		px: 1,
		mb: 2,
		flexShrink: 0,
	},
	title: {
		gridColumn: {
			md: 2,
		},
		fontWeight: 700,
		textAlign: 'center',
		lineHeight: 1.3,
	},
	actions: {
		gridColumn: {
			md: 3,
		},
		justifySelf: {
			xs: 'center',
			md: 'end',
		},
	},
} as const satisfies SxType
